import React, { useEffect, useRef, useState } from "react";

export default function ArticleImportDropZone({ disabled, loaded, onFile, onError, children }) {
  const [dragging, setDragging] = useState(false);
  const depth = useRef(0);
  useEffect(() => {
    if (disabled) { depth.current = 0; setDragging(false); }
  }, [disabled]);
  const hasFiles = event => Array.from(event.dataTransfer.types || []).includes("Files");
  return <section aria-label="Zona e ngarkimit të Excel-it" data-disabled={Boolean(disabled)}
    className={`article-import-page__card article-import-page__upload ${loaded ? "article-import-page__upload--loaded" : ""} ${dragging ? "article-import-page__upload--dragging" : ""}`}
    onDragEnter={event => {
      if (!hasFiles(event)) return;
      event.preventDefault();
      if (!disabled) { depth.current++; setDragging(true); }
    }}
    onDragOver={event => {
      if (!hasFiles(event)) return;
      event.preventDefault();
      event.dataTransfer.dropEffect = disabled ? "none" : "copy";
    }}
    onDragLeave={event => {
      event.preventDefault();
      depth.current = Math.max(0, depth.current - 1);
      if (!depth.current) setDragging(false);
    }}
    onDrop={event => {
      event.preventDefault();
      depth.current = 0;
      setDragging(false);
      if (disabled) return;
      const files = Array.from(event.dataTransfer.files || []);
      if (files.length > 1) { onError("Ngarkoni vetëm një Excel njëherësh. U lëshuan disa skedarë; zgjidhni vetëm njërin."); return; }
      if (files.length === 1) onFile(files[0]);
    }}>
    {children}
    <span className="article-import-page__drop-hint" role="status">{dragging ? "Lëshojeni Excel-in këtu për ngarkim" : "Ose tërhiqeni dhe lëshojeni Excel-in këtu · .xlsx, deri në 100 MB"}</span>
  </section>;
}
